import useDeletingPage from './admin/useDeletingPage';
import useSimpleTabs from './volunteers/useSimpleTabs';

export { useDeletingPage, useSimpleTabs };
